
import { useLocation } from 'react-router-dom';
export interface LoginLocationState {
    redirectTo?: string;
    provider?: string;
    clientId?: string;
}

export function useLoginLocation() {
    return useLocation() as ReturnType<typeof useLocation> & {
        state: LoginLocationState | null;
    };
}